import React from 'react';
import { LanguageConsumer } from '../config/LanguageContext';

export default (Component) => function withLanguageContext(props) {
  return (
    <LanguageConsumer>
      {({ language }) => (
        <Component
          {...props} // eslint-disable-line react/jsx-props-no-spreading
          language={language}
        />
      )}
    </LanguageConsumer>
  );
};
